import React from 'react';
import { Skeleton } from 'modules/Core/Common';

import * as S from './WidgetFilters.styles';

export const WidgetFiltersLoading = () => {
  return (
    <S.LoadingContainer>
      {[1, 2, 3].map((item) => (
        <div key={item} className="skeleton-container">
          <Skeleton type="string" />
        </div>
      ))}
    </S.LoadingContainer>
  );
};
